import { BaseController } from '@shared/basecontroller.controller';
import EVENTS from '@shared/events';
import { TabsModel } from './model/tabs.model';

class DepositController extends BaseController {
  constructor(CustomerApiService, TransactionApiService, EventDispatcherService, SessionService) {
    'ngInject';

    super();

    this.CustomerApiService = CustomerApiService;
    this.TransactionApiService = TransactionApiService;
    this.EventDispatcherService = EventDispatcherService;
    this.SessionService = SessionService;

    this.SessionService.session.map((session) => {
      if (session) {
        this.userCurrency = session.currency;
      } else {
        this.userCurrency = null;
      }
    });

    this.customerProducts = null;
    this.paymentOptions = null;
    this.tabsModel = null;
    this.selectedTabItem = null;
  }

  $onInit() {
    this.addSubscription(this.EventDispatcherService.addListener(EVENTS.BET_PROCESSED, event => this.loadProducts()));
    this.addSubscription(this.EventDispatcherService.addListener(EVENTS.BTC_EXCHANGE_RATE, event => {
      let bitcoinRate = event.bitcoinRate;
    }));

    this.TransactionApiService.getPaymentOptions().then(paymentOptions => {
      this.paymentOptions = paymentOptions;
      this.tabsModel = TabsModel.fromPaymentOptions(this.paymentOptions);
      this.selectedTabItem = this.tabsModel.selectedTabItem;
    });

    this.loadProducts();
  }

  onTabSelected(tabItem) {
    this.tabsModel.selectTabItem(tabItem);
    this.selectedTabItem = tabItem;
  }

  loadProducts() {
    this.CustomerApiService.getProducts().then(customerProducts => this.customerProducts = customerProducts);
  }
}

export default DepositController;



// WEBPACK FOOTER //
// ./client/app/pages/customer/deposit2/deposit.controller.js